// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import { Loading } from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'
import Post from './api/post';
import Get from './api/get';
import vueSwiper from 'vue-awesome-swiper'
Vue.use(vueSwiper)
import 'swiper/css/swiper.css'
Vue.use(Loading);
Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.axios = axios
// Vue.prototype.$video = Video
// if (process.env.NODE_ENV == 'production') {
//   console.log( process.env.VUE_APP_HOST)
//     Vue.prototype.axios.defaults.baseURL = process.env.VUE_APP_HOST
// } else {
//   console.log( process.env.VUE_APP_HOST)
    Vue.prototype.axios.defaults.baseURL = 'https://api-prod.tuoluo.cn/api'
// }
Vue.prototype.$Post = Post;
Vue.prototype.$Get = Get;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created(){
    setHtmlFontSize();
  }
})
// 手机端rem换算
function setHtmlFontSize (){
  const htmlDom = document.getElementsByTagName('html')[0];
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  if (htmlWidth > 1200) {
    location = "https://www.tuoluo.cn";
  }
  if (htmlWidth >= 750) {
    htmlWidth = 750;
  }
  if (htmlWidth <= 320) {
    console.log(99999)
    htmlWidth = 320;
  }
  
  htmlDom.style.fontSize = `${htmlWidth / 7.5}px`;
};
window.onresize = setHtmlFontSize;



// WEBPACK FOOTER //
// ./src/main.js